<template>
  <div class="requirements-content">
    <div class="requirements-list">
      <div class="requirement-item">
        <FontAwesomeIcon :icon="faVolumeHigh" class="requirement-icon" size="lg" />
        <div class="requirement-text">
          <p>
            Ensure the screener takes place in a quiet environment to prevent background noise from
            affecting results.
          </p>
        </div>
      </div>
      <div class="requirement-item">
        <FontAwesomeIcon :icon="faHeadset" class="requirement-icon" size="lg" />
        <div class="requirement-text">
          <p>
            Use Mable-provided headsets - Depending on the device you may require an adapter, follow
            the device's connection guidelines in the screener guide.
          </p>
        </div>
      </div>
      <div class="requirement-item">
        <FontAwesomeIcon :icon="faPeopleArrows" class="requirement-icon" size="lg" />
        <div class="requirement-text">
          <p>
            Set up each pupil approximately 2 metres or more apart to maintain focus and minimize
            interference.
          </p>
        </div>
      </div>
      <div class="requirement-item">
        <FontAwesomeIcon :icon="faDesktop" class="requirement-icon" size="lg" />
        <div class="requirement-text">
          <p>
            Keep teacher widget visible on Mable platform (Located in the bottom left of the class
            screener page.)
          </p>
        </div>
      </div>
      <div class="requirement-item">
        <FontAwesomeIcon :icon="faClock" class="requirement-icon" size="lg" />
        <div class="requirement-text">
          <p>
            Stagger screener start times to avoid overlapping responses or misattributed answers
            between pupils.
          </p>
        </div>
      </div>
    </div>
    <a :href="setupGuideLink" target="_blank" class="setup-guide-link">
      <FontAwesomeIcon :icon="faBook" class="requirement-icon" size="lg" />
      View screener guide
    </a>
  </div>
</template>
<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faHeadset,
  faPeopleArrows,
  faDesktop,
  faClock,
  faBook,
  faVolumeHigh
} from '@fortawesome/free-solid-svg-icons'

const setupGuideLink = _SCREENER_HELP_GUIDE_URL_
</script>
<style lang="scss" scoped>
.requirements {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0;
  margin: 0 1rem;

  .requirements-content {
    .requirements-list {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin-bottom: 1.5rem;

      .requirement-item {
        display: flex;
        gap: 1rem;
        padding-bottom: 0.75rem;
        align-items: center;

        .requirement-icon {
          color: $primary;
        }

        .requirement-text {
          flex: 1;
          line-height: 1.4;
        }
      }
    }

    .setup-guide-link {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      color: $primary;
      font-weight: 600;
      padding: 0.75rem;
      border: 2px solid $primary;
      border-radius: 8px;
      transition: all 0.2s ease;
      text-decoration: none;

      &:hover {
        background-color: $primary;
        color: $white;
      }
    }
  }
}
</style>
